type SharetribeUser = {
  profileImage?: { attributes?: { variants?: Record<string, { url?: string }> } };
};

const PRIMARY_VARIANTS = ['square-small2x', 'square-small', 'default'];

/**
 * Pick the best available avatar URL from a Sharetribe user's profileImage.
 * Returns undefined when the user has no profile image so the caller can
 * render the marketplace's standard empty-avatar placeholder.
 */
export const getAvatarUrl = (user: SharetribeUser | null | undefined): string | undefined => {
  const variants = user?.profileImage?.attributes?.variants;
  if (!variants) return undefined;
  for (const key of PRIMARY_VARIANTS) {
    if (variants[key]?.url) return variants[key].url;
  }
  return undefined;
};
